(function ($) {

    const initializeBlock = function ($block) {
      function matchHeightFire() {
        $('.fleetGrid .fleetGrid-item .fleetGrid-machine_image').matchHeight( {property: 'min-height'} );
      }
      matchHeightFire()

      $( window ).bind('resize orientationchange', function() {
          matchHeightFire();
      });

      setTimeout(function() {
          matchHeightFire();
      }, 1000)
    }

    $(document).ready(function () {
        $('.block--fleet-grid').each(function () {
            initializeBlock($(this));
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=fleet-grid', initializeBlock);
    }

})(jQuery);
